export default function normalizeSearchInput(input: string) {
  const raw = input.trim()
  const lower = raw.toLowerCase()

  // 1. Clean: Pinyin without tones (e.g., "yi2 si4" -> "yisi")
  // We send this, but the Backend IGNORES it if numbers are present.
  const clean = lower
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z]/g, '')

  // 2. Num: Pinyin with numbers (e.g., "yi2 si4" -> "yi2si4")
  // Used for Strict Matching.
  const num = lower
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '') // Keep numbers

  return { raw, clean, num }
}
